import React from "react";
import { range } from "./util";

var Table = function Table(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      hideColumnIndicators = _ref.hideColumnIndicators;
  var columnCount = columns + (hideColumnIndicators ? 0 : 1);
  var columnNodes = range(columnCount).map(function (i) {
    return /*#__PURE__*/React.createElement("col", {
      key: i
    });
  });
  return /*#__PURE__*/React.createElement("table", {
    className: "Spreadsheet__table"
  }, /*#__PURE__*/React.createElement("colgroup", null, columnNodes), /*#__PURE__*/React.createElement("tbody", null, children));
};

export default Table;